import SchoolGroupVacancies from './SchoolGroupVacancies.page';

export default SchoolGroupVacancies;
